import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

// Types generated from OpenAPI spec
export type SpotifyCredentialRequest =
  components["schemas"]["SpotifyCredentialRequest"];

type ApiResponseSpotifyCredential =
  components["schemas"]["ApiResponse_SpotifyCredentialRequest_"];
type ApiResponseSpotifyCredentialOrNull =
  components["schemas"]["ApiResponse_SpotifyCredentialRequest-or-null_"];
type ApiResponseSpotifyCallback =
  components["schemas"]["ApiResponse_SpotifyCallbackParams_"];
type ApiResponseSpotifyAdAccounts =
  components["schemas"]["ApiResponse_SpotifyAdAccountsResponse_"];
type ApiResponseSpotifyCodeExchange =
  components["schemas"]["ApiResponse_SpotifyCodeExchangeResponse_"];
type ApiResponseSpotifyAuthorizeUrl =
  components["schemas"]["ApiResponse__authorizeUrl-string__"];

type SpotifyCodeExchangeRequest =
  components["schemas"]["SpotifyCodeExchangeRequest"];

interface SpotifyAdAccountsParams {
  businessId?: string;
  limit?: number;
  offset?: number;
}

type SpotifyCallbackParams = {
  code?: string;
  state?: string;
  error?: string;
};

export const spotifyApi = createApi({
  reducerPath: "spotifyApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SpotifyCredentials"],
  endpoints: (builder) => ({
    getSpotifyCredentials: builder.query<
      ApiResponseSpotifyCredentialOrNull,
      void
    >({
      query: () => ({
        url: "/spotify/credentials",
      }),
      providesTags: ["SpotifyCredentials"],
    }),
    upsertSpotifyCredentials: builder.mutation<
      ApiResponseSpotifyCredential,
      SpotifyCredentialRequest
    >({
      query: (body) => ({
        url: "/spotify/credentials",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SpotifyCredentials"],
    }),
    handleSpotifyCallback: builder.query<
      ApiResponseSpotifyCallback,
      SpotifyCallbackParams
    >({
      query: (params) => ({
        url: "/spotify/callback",
        params: Object.fromEntries(
          Object.entries(params || {}).filter(
            ([, value]) => value !== undefined
          )
        ),
      }),
    }),
    authorizeSpotify: builder.query<ApiResponseSpotifyAuthorizeUrl, void>({
      query: () => ({
        url: "/spotify/authorize",
      }),
    }),
    getSpotifyAdAccounts: builder.query<
      ApiResponseSpotifyAdAccounts,
      SpotifyAdAccountsParams | void
    >({
      query: (params) => ({
        url: "/spotify/ad-accounts",
        params:
          params && Object.keys(params).length > 0
            ? Object.fromEntries(
                Object.entries(params).filter(
                  ([, value]) => value !== undefined
                )
              )
            : undefined,
      }),
    }),
    exchangeSpotifyCode: builder.mutation<
      ApiResponseSpotifyCodeExchange,
      SpotifyCodeExchangeRequest
    >({
      query: (body) => ({
        url: "/spotify/exchange-code",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SpotifyCredentials"],
    }),
  }),
});

export const {
  useGetSpotifyCredentialsQuery,
  useUpsertSpotifyCredentialsMutation,
  useLazyHandleSpotifyCallbackQuery,
  useLazyAuthorizeSpotifyQuery,
  useGetSpotifyAdAccountsQuery,
  useLazyGetSpotifyAdAccountsQuery,
  useExchangeSpotifyCodeMutation,
} = spotifyApi;
